import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    outline: 0;
    padding: 0;
    font-family: 'Roboto';
    -webkit-font-smoothing: antialiased;
    box-sizing: border-box;
  }

  html, body, #__next {
    width: 100%;
    height: 100%;
    overflow: auto;
    overflow-x: hidden !important;
  }

  button {
    border: none;
    background: none;
    font-weight: bold;
    cursor: pointer;
  }

  #__next {
    z-index: 0;
    > main {
      height: 100%;
    }
  }

  a {
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

::-webkit-scrollbar {
  width: 6px;
  height: 8px; 
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 3px; 
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.5); 
}

::-webkit-scrollbar-track:hover {
  background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar-corner {
  background: transparent;
}

  #portal-root {
    overflow: visible;
  }
`;
